import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	width: 100,
	height: 100,
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M 24 3 C 12.413858 3 3 12.413866 3 24 C 3 35.586134 12.413858 45 24 45 C 35.586142 45 45 35.586134 45 24 C 45 12.413866 35.586142 3 24 3 z M 24 5 C 34.505263 5 43 13.494744 43 24 C 43 34.505256 34.505263 43 24 43 C 13.494737 43 5 34.505256 5 24 C 5 13.494744 13.494737 5 24 5 z M 33.951172 15.990234 A 1.0001 1.0001 0 0 0 33.208984 16.388672 L 22.244141 30.568359 L 14.640625 24.232422 A 1.0001 1.0001 0 1 0 13.359375 25.767578 L 21.759766 32.767578 A 1.0001 1.0001 0 0 0 23.191406 32.611328 L 34.791016 17.611328 A 1.0001 1.0001 0 0 0 33.951172 15.990234 z" })
});
export default SvgSuccess;
